import { injectable } from 'tsyringe';
import { PengajuanPelatihanApiRepository } from '../../app/repository/api/PengajuanPelatihanApiRepository';
import { PengajuanPelatihan } from '../../entities/PengajuanPelatihan';

@injectable()
export class PengajuanPelatihanPresenter {
  private repository: PengajuanPelatihanApiRepository;
  constructor(repository: PengajuanPelatihanApiRepository) {
    this.repository = repository;
  }

  public getAllPengajuanPelatihan(
    page: number,
    rows: number,
    keyword: string,
    tahun: string,
    sub_menu_jenis_pelatihan_id: string,
    event_id: string | null
  ): Promise<PengajuanPelatihan[]> {
    return this.repository.getAllPengajuanPelatihan(
      page,
      rows,
      keyword,
      tahun,
      sub_menu_jenis_pelatihan_id,
      event_id
    );
  }

  public getDetailPengajuanPelatihan(id: number): Promise<PengajuanPelatihan> {
    return this.repository.getDetailPengajuanPelatihan(id);
  }

  public storePengajuanPelatihan(
    sub_menu_jenis_pelatihan_id: number,
    jenis_pelatihan_id: number,
    judul_pelatihan: string,
    jenis_penilaian_id: string,
    waktu_buka_pendaftaran: string,
    waktu_tutup_pendaftaran: string,
    waktu_mulai: string,
    waktu_selesai: string,
    penyelenggara: string,
    informasi_umum: string,
    persyaratan: string,
    angkatan: string,
    kompetensi_teknis: string,
    is_ppkb: boolean,
    materi_inti: string,
    is_for_guru_madrasah: boolean,
    path_thumbnail: File,
    link_evaluasi: string,
    logo_penyelenggara: File
  ): Promise<any> {
    return this.repository.storePengajuanPelatihan(
      sub_menu_jenis_pelatihan_id,
      jenis_pelatihan_id,
      judul_pelatihan,
      jenis_penilaian_id,
      waktu_buka_pendaftaran,
      waktu_tutup_pendaftaran,
      waktu_mulai,
      waktu_selesai,
      penyelenggara,
      informasi_umum,
      persyaratan,
      angkatan,
      kompetensi_teknis,
      is_ppkb,
      materi_inti,
      is_for_guru_madrasah,
      path_thumbnail,
      link_evaluasi,
      logo_penyelenggara
    );
  }

  public updatePengajuanPelatihan(
    id: number,
    sub_menu_jenis_pelatihan_id: number,
    jenis_pelatihan_id: number,
    judul_pelatihan: string,
    jenis_penilaian_id: string,
    waktu_buka_pendaftaran: string,
    waktu_tutup_pendaftaran: string,
    waktu_mulai: string,
    waktu_selesai: string,
    penyelenggara: string,
    informasi_umum: string,
    persyaratan: string,
    angkatan: string,
    kompetensi_teknis: string,
    is_ppkb: boolean,
    materi_inti: string,
    is_for_guru_madrasah: boolean,
    path_thumbnail: File,
    status_pengajuan: string,
    link_evaluasi: string,
    logo_penyelenggara: File
  ): Promise<any> {
    return this.repository.updatePengajuanPelatihan(
      id,
      sub_menu_jenis_pelatihan_id,
      jenis_pelatihan_id,
      judul_pelatihan,
      jenis_penilaian_id,
      waktu_buka_pendaftaran,
      waktu_tutup_pendaftaran,
      waktu_mulai,
      waktu_selesai,
      penyelenggara,
      informasi_umum,
      persyaratan,
      angkatan,
      kompetensi_teknis,
      is_ppkb,
      materi_inti,
      is_for_guru_madrasah,
      path_thumbnail,
      status_pengajuan,
      link_evaluasi,
      logo_penyelenggara
    );
  }

  public updateStatusPengajuanPelatihan(
    id: number,
    status_pengajuan: string,
    alasan: string
  ): Promise<any> {
    return this.repository.updateStatusPengajuanPelatihan(
      id,
      status_pengajuan,
      alasan
    );
  }

  public deletePengajuanPelatihan(id: number): Promise<any> {
    return this.repository.deletePengajuanPelatihan(id);
  }
}
